import { useToggleTipContext } from '../components/ToggleTipProvider.js';
import { CLOSE_TOGGLETIP } from '../actions.js';

/**
 * useToggleTipPopover
 *
 * provide popover functions
 * https://github.com/reach/reach-ui/tree/main/packages/popover
 *
 */
var popoverContainsEventTarget = function (popover, target) {
    return !!(popover && popover.contains(target));
};
var useToggleTipPopover = function () {
    var _a = useToggleTipContext(), buttonRef = _a.buttonRef, buttonClickedRef = _a.buttonClickedRef, dispatch = _a.dispatch, popoverRef = _a.popoverRef, isOpen = _a.state.isOpen;
    var mouseListener = function (event) {
        if (buttonClickedRef.current) {
            buttonClickedRef.current = false;
        }
        if (!popoverContainsEventTarget(popoverRef.current, event.target)) {
            // We want to close only if focus rests outside the popover
            dispatch({ type: CLOSE_TOGGLETIP });
        }
    };
    // close popover if click enter/space outside the popover, or click escape anywhere
    var keyListener = function (event) {
        if (event.key === "Escape") {
            if (isOpen) {
                dispatch({ type: CLOSE_TOGGLETIP });
                buttonRef && buttonRef.current && buttonRef.current.focus();
            }
            return;
        }
        if (buttonClickedRef.current) {
            buttonClickedRef.current = false;
        }
        if (event.target !== buttonRef.current &&
            !popoverContainsEventTarget(popoverRef.current, event.target)) {
            // We want to close only if focus rests outside the popover
            switch (event.key) {
                case "Enter":
                case " ":
                    if (isOpen) {
                        dispatch({ type: CLOSE_TOGGLETIP });
                    }
                    break;
            }
        }
    };
    return {
        mouseListener: mouseListener,
        keyListener: keyListener,
    };
};

export { useToggleTipPopover };
//# sourceMappingURL=useToggleTipPopover.js.map
